export default [
  {
    path: '/innerGoods/showTimeLimit',
    name: 'showTimeLimit',
    meta: {
      title: '限时折扣'
    },
    component(resolve) {
      require(['COMPONENTS/innerGoods/showTimeLimit/main.vue'], resolve)
    }
  },
  {
    path: '/innerGoods/editTimeLimit',
    name: 'editTimeLimit',
    meta: {
      title: '限时折扣管理'
    },
    component(resolve) {
      require(['COMPONENTS/innerGoods/editTimeLimit/main.vue'], resolve)
    }
  },
]